import React, { Component } from "react";
import Paper from "@mui/material/Paper";
import {
  FormControlLabel,
  InputLabel,
  Select,
  TextField,
  Typography,
  Button,
  FormControl,
  FormHelperText,
  Chip,
  List,
  ListItem,
  MenuItem,
  Radio,
  RadioGroup,
  Dialog,
  DialogTitle,
  Alert,
  Collapse,
  Grid,
  NativeSelect,
} from "@mui/material";
import "./css/InverterSelectorForm.css";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { Card, CardHeader, CardContent } from "@mui/material";

export class AuxBreakerView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listSize: this.props.listSize,
      listIndex: 0,
      maxAux:
        this.props.userOPdata[this.props.data.modelIndex][
          "Aux Circuit Breakers"
        ],
      numOfBreakers: this.props.numOfBreakers,
      ablist: this.props.auxBreakerConfig,
      showCustomConfig: this.props.numOfBreakers > 0 ? true : false,
      tempNum: this.props.numOfBreakers,
      tempAmp: 20,
      tempVolt: this.props.data.ovData,
      tempOutputType: "Normally On",
      errorOpenDialog: false,
      open: false,
      showAddBreakerButton: true,
      editIndex: null,
    };
  }

  increaseListSize = () => {
    if (
      this.state.listSize <
      this.props.userOPdata[this.props.data.modelIndex]["Aux Circuit Breakers"]
    ) {
      this.setState(
        (prevState) => ({ listSize: prevState.listSize + 1 }),
        () => {
          this.setState(
            (prevState) => {
              const updatedAblist = [...prevState.ablist];
              updatedAblist.push({
                Num: this.state.tempNum,
                A: this.state.tempAmp,
                V: this.state.tempVolt,
                O: this.state.tempOutputType,
              });
              return {
                ablist: updatedAblist,
              };
            },
            () => {
              this.props.setAuxBreakerConfig(
                this.state.ablist,
                this.state.numOfBreakers,
                this.state.listSize
              );
            }
          );
        }
      );
    }
  };

  addBreakerButton = (event) => {
    if (this.state.numOfBreakers < this.state.maxAux) {
      this.setState({ open: true });
    } else {
      this.setState({ showAddBreakerButton: false });
    }
  };

  customAuxBreaker = (event) => {
    if (event.target.value === "1") {
      this.setState({ showCustomConfig: true });
      this.addBreakerButton();
    } else {
      this.setState({ showCustomConfig: false });
    }
  };

  addtempNum = (event) => {
    if (event.target.value <= 0) {
      //event.target.value = "";
    }
    if (
      parseInt(event.target.value) + this.state.numOfBreakers <=
      this.state.maxAux
    ) {
      this.setState({ tempNum: event.target.value }, () => {
        console.log("Saved tempNum:", this.state.tempNum);
      });
    } else {
      this.setState({ tempNum: "Error" }, () => {
        //console.log(this.state.tempNum);
      });
    }
  };

  setTempAmp = (data) => {
    this.setState({ tempAmp: data });
  };

  setTempVolt = (data) => {
    //if 3p or 2p
    // trigger to show another row below
    this.setState({ tempVolt: data });
    console.log("Test1", data);
  };

  setTempOutputType = (data) => {
    this.setState({ tempOutputType: data });
  };

  handleClose = () => {
    this.setState({ open: false });
    this.setState({ editIndex: null });
  };

  editButton = (index) => {
    this.setState({ tempNum: this.state.ablist[index]["Num"] });
    this.setState({ tempAmp: this.state.ablist[index]["A"] });
    this.setState({ tempVolt: this.state.ablist[index]["V"] });
    this.setState({ tempOutputType: this.state.ablist[index]["O"] });
    this.setState({ editIndex: index });
    this.setState({
      numOfBreakers: this.state.numOfBreakers - this.state.ablist[index]["Num"],
    });
    this.setState({ open: true });

    if (this.state.numOfBreakers < this.state.maxAux) {
      this.setState({ showAddBreakerButton: true });
    } else {
      this.setState({ showAddBreakerButton: false });
    }
  };

  deleteRow = (index) => {
    this.setState(
      {
        numOfBreakers:
          this.state.numOfBreakers - this.state.ablist[index]["Num"],
      },
      () => {
        //console.log(index);
        this.state.ablist.splice(index, 1);

        //console.log(this.state.ablist);

        this.setState({ ablist: this.state.ablist });

        this.props.setAuxBreakerConfig(
          this.state.ablist,
          this.state.numOfBreakers,
          this.state.listSize
        );

        //Show add button again
        this.setState({ showAddBreakerButton: true });
      }
    );
  };

  clickSave = () => {
    if (this.state.tempNum === "Error") {
      this.setState({ open: true });
      console.log("Error tempNNum");
      if (this.state.numOfBreakers > 0) {
        this.setState({
          numOfBreakers:
            this.state.numOfBreakers +
            this.state.ablist[this.state.editIndex]["Num"],
        });
      }
      this.setState({ errorOpenDialog: true });
    } else {
      //Load Buffer
      if (this.state.editIndex != null) {
        this.state.ablist.splice(this.state.editIndex, 1);
        this.setState({ editIndex: null });
      }

      let a = this.state.tempNum || 0;
      let b = this.state.numOfBreakers || 0;

      //Set data to all field.
      let total = parseInt(a) + parseInt(b);

      //parseInt(this.state.tempNum) + parseInt(this.state.numOfBreakers);
      this.setState({ numOfBreakers: total });
      if (total === this.state.maxAux) {
        this.setState({ showAddBreakerButton: false });
      }

      //Set data
      this.setState({ errorOpenDialog: false });
      //Close Dialog Box
      this.setState({ open: false });
      //Increase List
      this.increaseListSize();

      console.log("volt", this.state.tempVolt);
      console.log("total: ", total);
    }
  };

  //OnSelect for Sub Feed Panel Desired Amps
  onChangeDesiredAmps = () => {};

  //Handle Sub Feed Panel Breakers

  handleChangeSubFeedPanelBreakers = (data, index) => {
    this.props.setSFB1(data, index);
  };

  render() {
    const { showCustomConfig } = this.state;

    return (
      //App starts here

      <Card elevation={10}>
        <CardHeader
          titleTypographyProps={{
            fontFamily: "Ford-Normal",
          }}
          className="paperh-title"
          title="Aux Breaker"
        />
        <CardContent className="ab-cardcontent">
          <Paper className="ab-Paper" elevation={5}>
            <Typography style={{ fontFamily: "Ford-Normal" }}>
              {" "}
              Do you want to add Aux Breakers
            </Typography>

            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
                onChange={this.customAuxBreaker}
                defaultValue={this.state.showCustomConfig ? 1 : null}
                sx={{ "& .MuiTypography-root": { fontFamily: "Ford-Normal" } }}
              >
                <FormControlLabel value="1" control={<Radio />} label="Yes" />
                <FormControlLabel value="2" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>

            {showCustomConfig && (
              <Paper className="ab-Paper" elevation={0}>
                <Typography
                  style={{ fontFamily: "Ford-Normal" }}
                  variant="h7"
                  className="ab-Paper-Header"
                >
                  {" "}
                  Based on your Model Series you have a Maximum of:{" "}
                  <Chip
                    label={this.state.maxAux + " Poles"}
                    className="chip-container"
                    sx={{
                      m: 1,
                      fontFamily: "Ford-Normal",
                    }}
                  />
                  <Chip
                    label={
                      this.state.maxAux +
                      " Breakers / " +
                      this.state.maxAux +
                      " Poles"
                    }
                    className="chip-container"
                    sx={{
                      m: 1,
                      fontFamily: "Ford-Normal",
                    }}
                  />
                </Typography>
              </Paper>
            )}
          </Paper>

          {showCustomConfig && (
            <Paper>
              <Typography
                style={{ fontFamily: "Ford-Normal" }}
                variant="h7"
                className="ab-Paper-Header2"
              >
                {" "}
                Current Aux Breaker Configuration
                <Chip
                  label={`${this.state.numOfBreakers} / ${this.state.maxAux} AuxBreakers`}
                  className="chip-container"
                  sx={{
                    m: "0 0 0 5px",
                    marginLeft: "5px",
                    fontFamily: "Ford-Normal",
                  }}
                />
              </Typography>
              <Dialog
                onClose={this.handleClose}
                open={this.state.open}
                maxWidth="lg"
              >
                <DialogTitle style={{ fontFamily: "Ford-Normal" }}>
                  Set Breaker Configuration
                </DialogTitle>
                <Paper>
                  <FormControl>
                    <TextField
                      InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
                      type="number"
                      sx={{
                        m: 1,
                        width: "90%",
                        fontFamily: "Ford-Normal",
                      }}
                      onChange={this.addtempNum}
                      label="Number of Breakers"
                      defaultValue={this.state.tempNum}
                      helperText="This is the number of Breakers with this configuration"
                    ></TextField>
                    <FormHelperText></FormHelperText>
                  </FormControl>
                  <FormControl variant="standard" sx={{ m: 1, minWidth: 100 }}>
                    <InputLabel
                      style={{ fontFamily: "Ford-Normal" }}
                      id="demo-simple-select-standard-label"
                    >
                      Amps
                    </InputLabel>
                    <Select
                      style={{ fontFamily: "Ford-Normal" }}
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      label="Amps"
                      defaultValue={
                        this.props.userOPdata[this.props.data.modelIndex][
                          "Name"
                        ] === "Mini Power Wave" ||
                        this.props.userOPdata[this.props.data.modelIndex][
                          "Name"
                        ] === "Micro Power Wave"
                          ? "20"
                          : this.state.tempAmp
                      }
                      onChange={(event) => this.setTempAmp(event.target.value)}
                    >
                      {this.props.userOPdata[this.props.data.modelIndex][
                        "Name"
                      ] === "Mini Power Wave" ||
                      this.props.userOPdata[this.props.data.modelIndex][
                        "Name"
                      ] === "Micro Power Wave" ? (
                        <MenuItem key={20} value={20}>
                          20 Amps
                        </MenuItem>
                      ) : (
                        [
                          <MenuItem
                            style={{ fontFamily: "Ford-Normal" }}
                            key={10}
                            value={10}
                          >
                            10 Amps
                          </MenuItem>,
                          <MenuItem
                            style={{ fontFamily: "Ford-Normal" }}
                            key={20}
                            value={20}
                          >
                            20 Amps
                          </MenuItem>,
                          <MenuItem
                            style={{ fontFamily: "Ford-Normal" }}
                            key={15}
                            value={15}
                          >
                            15 Amps
                          </MenuItem>,
                          <MenuItem
                            style={{ fontFamily: "Ford-Normal" }}
                            key={25}
                            value={25}
                          >
                            25 Amps
                          </MenuItem>,
                          <MenuItem
                            style={{ fontFamily: "Ford-Normal" }}
                            key={30}
                            value={30}
                          >
                            30 Amps
                          </MenuItem>,
                          <MenuItem
                            style={{ fontFamily: "Ford-Normal" }}
                            key={40}
                            value={40}
                          >
                            40 Amps
                          </MenuItem>,
                          <MenuItem
                            style={{ fontFamily: "Ford-Normal" }}
                            key={50}
                            value={50}
                          >
                            50 Amps
                          </MenuItem>,
                          <MenuItem
                            style={{ fontFamily: "Ford-Normal" }}
                            key={60}
                            value={60}
                          >
                            60 Amps
                          </MenuItem>,
                        ]
                      )}
                    </Select>
                    <FormHelperText> </FormHelperText>
                  </FormControl>

                  {this.props.userOPdata[this.props.data.modelIndex]["Name"] !==
                    "Micro Power Wave" && (
                    <FormControl
                      variant="standard"
                      sx={{ m: 1, minWidth: 120 }}
                    >
                      <InputLabel
                        style={{ fontFamily: "Ford-Normal" }}
                        id="demo-simple-select-standard-label"
                      >
                        Volts
                      </InputLabel>
                      <Select
                        style={{ fontFamily: "Ford-Normal" }}
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        label="Volts"
                        defaultValue={
                          this.props.userOPdata[this.props.data.modelIndex][
                            "Name"
                          ] === "Mini Power Wave"
                            ? this.props.data.ovData
                            : this.props.data.ovData
                        }
                        onChange={(event) =>
                          this.setTempVolt(event.target.value)
                        }
                      >
                       
                        {this.props.data.ovData === "120V, 1P" &&
                          this.props.userOPdata[this.props.data.modelIndex][
                            "Name"
                          ] === "Mini Power Wave" && (
                            <MenuItem
                              style={{ fontFamily: "Ford-Normal" }}
                              value={"120V, 1P"}
                              key="120V, 1P"
                            >
                              120V
                            </MenuItem>
                          )}

                        {String(this.props.data.ovData).includes("120") &&
                          this.props.userOPdata[this.props.data.modelIndex][
                            "Name"
                          ] !== "Mini Power Wave" && (
                            <MenuItem
                              style={{ fontFamily: "Ford-Normal" }}
                              value={"120V, 1P"}
                              key="120V 1P"
                            >
                              120V ,1P
                            </MenuItem>
                          )}

                        {String(this.props.data.ovData).includes("277") && (
                          <MenuItem
                            style={{ fontFamily: "Ford-Normal" }}
                            value={"277V, 1P"}
                            key="277V, 1P"
                          >
                            277V
                            {this.props.userOPdata[this.props.data.modelIndex][
                              "Name"
                            ] !== "Mini Power Wave"
                              ? ", 1P"
                              : ""}
                          </MenuItem>
                        )}

                        {String(this.props.data.ovData).includes("208") && (
                          <MenuItem
                            style={{ fontFamily: "Ford-Normal" }}
                            value={"208V, 2P"}
                            key="208V, 2P"
                          >
                            208V, 2P
                          </MenuItem>
                        )}

                        {String(this.props.data.ovData).includes("240") && (
                          <MenuItem
                            style={{ fontFamily: "Ford-Normal" }}
                            value={"240V, 2P"}
                            key="240V, 2P"
                          >
                            240V, 2P
                          </MenuItem>
                        )}

                        {String(this.props.data.ovData).includes("480") && (
                          <MenuItem
                            style={{ fontFamily: "Ford-Normal" }}
                            value={"480V, 2P"}
                            key="480V, 2P"
                          >
                            480V, 2P
                          </MenuItem>
                        )}
                      </Select>
                      <FormHelperText> </FormHelperText>
                    </FormControl>
                  )}
                  <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel
                      style={{ fontFamily: "Ford-Normal" }}
                      id="demo-simple-select-standard-label"
                    >
                      Output Type
                    </InputLabel>
                    <Select
                      style={{ fontFamily: "Ford-Normal" }}
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      label="Output Type"
                      defaultValue={this.state.tempOutputType}
                      onChange={(event) =>
                        this.setTempOutputType(event.target.value)
                      }
                    >
                      {this.props.userOPdata[this.props.data.modelIndex][
                        "Name"
                      ] === "Micro Power Wave"
                        ? [
                            <MenuItem
                              style={{ fontFamily: "Ford-Normal" }}
                              key={"Normally On"}
                              value="Normally On"
                            >
                              Normally On
                            </MenuItem>,
                          ]
                        : [
                            <MenuItem
                              style={{ fontFamily: "Ford-Normal" }}
                              key="Normally Off"
                              value="Normally Off"
                            >
                              Normally Off
                            </MenuItem>,
                            <MenuItem
                              style={{ fontFamily: "Ford-Normal" }}
                              key="Normally On"
                              value={"Normally On"}
                            >
                              Normally On
                            </MenuItem>,
                            <MenuItem
                              style={{ fontFamily: "Ford-Normal" }}
                              key={"Normally Off w/ Time Delay"}
                              value={"Normally Off w/ Time Delay"}
                            >
                              Normally Off w/ Time Delay
                            </MenuItem>,
                          ]}
                    </Select>
                    <FormHelperText> </FormHelperText>
                  </FormControl>
                  <Button
                    style={{ fontFamily: "Ford-Normal" }}
                    variant="contained"
                    onClick={this.clickSave}
                  >
                    Save
                  </Button>
                </Paper>
                <Collapse in={this.state.errorOpenDialog}>
                  <Alert
                    style={{ fontFamily: "Ford-Normal" }}
                    open={true}
                    severity="error"
                  >
                    Error
                  </Alert>
                </Collapse>
              </Dialog>
              <List>
                {this.state.ablist.map((item, index) => (
                  <ListItem key={`item-${item}`}>
                    <FormControl
                      variant="standard"
                      sx={{
                        m: 1,
                        minWidth: 50,
                        paddingLeft: 1,
                        fontFamily: "Ford-Normal",
                      }}
                    >
                      <TextField
                        InputLabelProps={{
                          style: { fontFamily: "Ford-Normal" },
                        }} // font size of input label
                        variant="filled"
                        label="Number of Breakers"
                        value={this.state.ablist[index]["Num"]}
                        helperText="This is the Number of Breakers with this configuration"
                      ></TextField>
                    </FormControl>
                    <FormControl
                      variant="standard"
                      sx={{ m: 1, minWidth: 100, paddingLeft: 1 }}
                    >
                      <TextField
                        InputLabelProps={{
                          style: { fontFamily: "Ford-Normal" },
                        }} // font size of input label
                        variant="filled"
                        label="Amps"
                        value={this.state.ablist[index]["A"]}
                        helperText=" "
                      ></TextField>
                    </FormControl>
                    {this.props.userOPdata[this.props.data.modelIndex][
                      "Name"
                    ] !== "Micro Power Wave" && (
                      <FormControl
                        variant="standard"
                        sx={{ m: 1, minWidth: 100, paddingLeft: 1 }}
                      >
                        <TextField
                          InputLabelProps={{
                            style: { fontFamily: "Ford-Normal" },
                          }} // font size of input label
                          variant="filled"
                          label="Volts"
                          value={this.state.ablist[index]["V"]}
                          helperText=" "
                        ></TextField>
                      </FormControl>
                    )}
                    <FormControl
                      variant="standard"
                      sx={{
                        m: 1,
                        minWidth: 100,
                        paddingLeft: 1,
                        fontFamily: "Ford-Normal",
                      }}
                    >
                      <TextField
                        style={{ fontFamily: "Ford-Normal" }}
                        InputLabelProps={{
                          style: { fontFamily: "Ford-Normal" },
                        }} // font size of input label
                        variant="filled"
                        id="outlined-search"
                        label="Output Type"
                        value={this.state.ablist[index]["O"]}
                        helperText=" "
                      ></TextField>
                    </FormControl>
                    <Button onClick={(event) => this.editButton(index)}>
                      Edit
                    </Button>
                    <Button onClick={(event) => this.deleteRow(index)}>
                      <DeleteForeverIcon></DeleteForeverIcon>
                    </Button>
                  </ListItem>
                ))}
                {this.state.showAddBreakerButton && (
                  <Button
                    style={{ fontFamily: "Ford-SemiBold" }}
                    onClick={this.addBreakerButton}
                  >
                    Add Breaker
                  </Button>
                )}
              </List>

              {this.props.data.productType !== "Micro Power Wave" &&
                this.props.data.productType !== "Mini Power Wave" && (
                  <Paper>
                    <CardHeader
                      titleTypographyProps={{
                        fontFamily: "Ford-Normal",
                      }}
                      title="2 Subfeed Output Breakers"
                      className="paperh-title"
                      subheader="Add Number of Sub Feed Breakers and desired Amps"
                    ></CardHeader>

                    <CardContent>
                      {/* First pair of text fields */}
                      <Grid
                        container
                        spacing={2}
                        justifyContent="center"
                        sx={{ marginTop: 2, marginBottom: 2 }}
                      >
                        <Grid item>
                          <FormControl fullWidth>
                            <InputLabel
                              variant="standard"
                              htmlFor="uncontrolled-native"
                              sx={{
                                minWidth: 250,
                                paddingLeft: 1,
                                paddingBottom: 1,
                                fontFamily: "Ford-Normal",
                              }}
                            >
                              Sub Feed Breaker 1 : Desired Amps
                            </InputLabel>
                            <NativeSelect
                              defaultValue={this.props.data.sfb1}
                              inputProps={{
                                name: "Desired Amps",
                                id: "uncontrolled-native",
                              }}
                              sx={{
                                minWidth: 250,
                                paddingLeft: 1,
                                paddingBottom: 1,
                                fontFamily: "Ford-Normal",
                              }}
                              onChange={(event) => {
                                this.handleChangeSubFeedPanelBreakers(
                                  event.target.value,
                                  1
                                );
                              }}
                            >
                              <option value="None">None</option>
                              <option value="15 Amps">15 Amps</option>
                              <option value="20 Amps">20 Amps</option>
                              <option value="30 Amps">30 Amps</option>
                              <option value="40 Amps">40 Amps</option>
                              <option value="50 Amps">50 Amps</option>
                              <option value="60 Amps">60 Amps</option>
                            </NativeSelect>
                          </FormControl>
                        </Grid>
                      </Grid>

                      {/* Second pair of text fields */}
                      <Grid
                        container
                        spacing={2}
                        justifyContent="center"
                        sx={{ marginTop: 2, marginBottom: 2 }}
                      >
                        <Grid item>
                          <FormControl fullWidth>
                            <InputLabel
                              variant="standard"
                              htmlFor="uncontrolled-native"
                              sx={{
                                minWidth: 250,
                                paddingLeft: 1,
                                paddingBottom: 1,
                                fontFamily: "Ford-Normal",
                              }}
                            >
                              Sub Feed Breaker 2 : Desired Amps
                            </InputLabel>
                            <NativeSelect
                              defaultValue={this.props.data.sfb2}
                              inputProps={{
                                name: "Desired Amps",
                                id: "uncontrolled-native",
                              }}
                              sx={{
                                minWidth: 250,
                                paddingLeft: 1,
                                paddingBottom: 1,
                                paddingTop: 1,
                                fontFamily: "Ford-Normal",
                              }}
                              onChange={(event) => {
                                this.handleChangeSubFeedPanelBreakers(
                                  event.target.value,
                                  2
                                );
                              }}
                            >
                              <option value="none"> None </option>
                              <option value="15 Amps">15 Amps</option>
                              <option value="20 Amps">20 Amps</option>
                              <option value="30 Amps">30 Amps</option>
                              <option value="40 Amps">40 Amps</option>
                              <option value="50 Amps">50 Amps</option>
                              <option value="60 Amps">60 Amps</option>
                            </NativeSelect>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Paper>
                )}
            </Paper>
          )}
        </CardContent>
      </Card>
    );
  }
}

export default AuxBreakerView;
